import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryMethod } from '@vendasta/marketplace-apps';

/*
 * Format delivery method for display.
 *
 * Usage:
 *   deliveryMethod | formatDeliveryMethod
 * Example:
 *   {{ 'DELIVERY_METHOD_PRODUCT' | formatDeliveryMethod }}
 *   formats to: 'Product'

*/
@Pipe({ standalone: true, name: 'formatDeliveryMethod' })
export class FormatDeliveryMethodPipe implements PipeTransform {
  transform(deliveryMethod: DeliveryMethod): string {
    return getDeliveryMethodString(deliveryMethod);
  }
}

function getDeliveryMethodString(deliveryMethod: DeliveryMethod): string {
  if (deliveryMethod === DeliveryMethod.DELIVERY_METHOD_SERVICE) {
    return 'Service';
  } else {
    return 'Product';
  }
}
